<template>
  <div>
    <div class="gameBg1">
      <div class="gameTitle"></div>
    </div>
    <div class="gameBg2">
      <!-- <div class="game_title1">
        赛制说明
        <div class="game_title1_line"></div>
      </div> -->
      <!-- <div class="game_title1_content">
        <p>
          赛制说明赛制说明赛制说明赛制说赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说
        </p>
        <p>
          赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说明赛制说
        </p>
      </div> -->

      <div class="game_title2">
        分赛道入口
        <div class="game_title2_line"></div>
      </div>
      <div class="game_title2_content">
        <div>
          <div class="gameSd" @click="toQandaPage">
            <div class="backGround"></div>
            <div class="writ">
              <div>综合交通+知识</div>
              <div>问答</div>
            </div>
          </div>
          <div class="gameSd" @click="toSub2Page">
            <div class="backGround"></div>
            <div class="writ">
              <div>城市轨道交通+领域知识</div>
              <div>问答</div>
            </div>
          </div>
          <!-- <div class="gameSd" @click="toSub3Page">
            <div class="backGround"></div>
            <div class="writ">
              <div>城市交通+法规标准知识</div>
              <div>问答</div>
            </div>
          </div> -->
        </div>
        <!-- <div> -->
          <!-- <div class="gameSd" @click="toQandaPage">
            <div class="backGround"></div>
            <div class="writ">
              <div>综合知识+交通</div>
              <div>问答</div>
            </div>
          </div> -->
          <!-- <div class="gameSd" @click="toQandaPage">
            <div class="backGround"></div>
            <div class="writ">
              <div>综合知识+交通</div>
              <div>问答</div>
            </div>
          </div> -->
          <!-- <div class="gameSd" @click="toQandaPage">
            <div class="backGround"></div>
            <div class="writ">
              <div>综合知识+交通</div>
              <div>问答</div>
            </div>
          </div> -->
        <!-- </div> -->
      </div>
    </div>
    <!-- <div class="gameButtomBg">
      <div class="gameButtomBg_title">
        联系我们
        <div class="gameButtomBg_line"></div>
        <p>如果您有任何问题，请联系neurips2024@alibaba.com</p>
        <div class="ourIcon"></div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'GamePage',
  methods: {
    toQandaPage () {
      this.$router.push('/qandaPage')
      window.scrollTo(0, 0)
    },
    toSub2Page () {
      this.$router.push('/sub2Page')
      window.scrollTo(0, 0)
    },
    toSub3Page () {
      this.$router.push('/sub3Page')
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: "FZLTZCHK";
  src: url("/src/assets/font/FZLTCHJW.TTF") format("truetype"); /* 使用webpack的别名&#126;@指向src目录 */
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "PingFangHeavy";
  src: url("/src/assets/font/PingFangHeavy.otf") format("truetype"); /* 使用webpack的别名&#126;@指向src目录 */
  font-weight: normal;
  font-style: normal;
}
.gameBg1 {
  background: url(/src/assets/img/gameBg1.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 4.4rem;
  .gameTitle {
    width: 9rem;
    height: 1.4rem;
    background: url(/src/assets/img/Game2024.png) no-repeat;
    background-size: contain;
    margin: 0 auto;
    transform: translateY(1.4rem);
  }
}
.gameBg2 {
  background: url(/src/assets/img/GameBg2.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 29rem;
  .game_title1,
  .game_title2 {
    text-align: center;
    padding-top: 0.9rem;
    // width: 7.27rem;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    .game_title1_line,
    .game_title2_line {
      margin: 0.15rem auto;
      width: 2.15rem;
      height: 0.05rem;
      background: url(/src/assets/img/game_title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .game_title1_content {
    width: 12rem;
    height: 12rem;
    background: radial-gradient(0% 0% at 0% 0%, #e0efff 0%, #f5f9ff 100%);
    box-shadow: 0 0.05rem 0.38rem 0.05rem #b1c6e8;
    border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
    padding: 0.48rem;
    margin: 0.76rem auto;
    p {
      width: 11rem;
      text-indent: 2em;
      font-family: FZLTZCHK;
      font-weight: normal;
      font-size: 0.24rem;
      color: #141414;
      line-height: 0.45rem;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
  .game_title2_content {
    width: 11.5rem;
    margin: 0 auto;
    margin-top: 0.6rem;
    div {
      // display: flex;
      float: left;
      .gameSd {
        margin: 0.6rem;
        width: 2.6rem;
        height: 3.4rem;
        background: #eaf4ff;
        box-shadow: 0px 0.05rem 0.38rem 0.05rem #b1c6e8;
        border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
        cursor: pointer;
        // flex: 1;
        .backGround {
          position: relative;
          background-image: url(/src/assets/img/car.png);
          background-size: 1.7rem 1.6rem;
          width: 1.7rem;
          height: 1.6rem;
          margin: 0 auto;
          margin-top: 0.4rem;
          margin-left: 0.43rem;
        }
        div {
          width: 1.7rem;
          text-align: center;
          font-family: FZLTZCHK;
          font-weight: normal;
          font-size: 0.24rem;
          color: #141414;
          // line-height: 48px;
          // text-align: center;
          margin-left: 0.23rem;
          margin-top: 0.16rem;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }
}
.gameButtomBg {
  background: url(/src/assets/img/buttomBg.png) no-repeat;
  background-size: 100% 100%;
  height: 7.3rem;
  width: 100%;
  margin-top: -1.9rem;
  .gameButtomBg_title {
    text-align: center;
    padding-top: 0.4rem;
    // width: 6rem;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
  }
  .gameButtomBg_line {
    margin: 0.15rem auto;
    width: 2.15rem;
    height: 0.05rem;
    background: url(/src/assets/img/game_title1_line.png) no-repeat;
    background-size: 100% 100%;
  }
  p {
    margin-top: 0.45rem;
    height: 0.24rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.22rem;
    color: #000000;
    line-height: 0.43rem;
  }
  .ourIcon {
    width: 2.03rem;
    height: 2rem;
    margin: 0 auto;
    margin-top: 0.8rem;
    background: #d2e9fe;
    box-shadow: 0.02rem 0.02rem 0.06rem 0.01rem rgba(130, 195, 255, 0.55);
    border-radius: 0.39rem;
  }
}
</style>
